<template>
	<div class="classificationBox">
		<el-button type="primary" @click="adddialogVisible()">{{$t('QuesLibrary.Tambah')}}</el-button>

		<el-table border :data="enumByData" style="width: 100%;margin-top:10px">
			<el-table-column prop="value" align="center" :label="$t('QuesLibrary.QuestionLabelName')"></el-table-column>
			<!-- <el-table-column label="回访类型">
				<template slot-scope="scope">
					<span v-if="scope.row.type == 'hflx'">回访类型</span>
					<span v-else>回访渠道</span>
				</template>
			</el-table-column> -->
			<el-table-column prop="type" align="center" :label="$t('QuesLibrary.Operate')">
				<template slot-scope="scope">
					<el-link @click="openEditEnumBy(scope.row)" type="primary" :underline="false">{{$t('QuesLibrary.Edit')}}</el-link>
					<el-popconfirm 
						style="margin-left: 10px;" 
						:title="$t('QuesLibrary.AreYouSureToDeleteIt')" 
						@confirm="delEnumBy(scope.row.id)"
					>
						<el-link slot="reference" type="primary" :underline="false">{{$t('QuesLibrary.Delete')}}</el-link>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination
				background
				@size-change="enumByhandleSizeChange"
				@current-change="enumByhandleCurrentChange"
				:current-page="enumBypagination.currentPage"
				:page-sizes="[1, 10, 50, 100, 200, 300, 400]"
				:page-size="enumBypagination.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="enumBypagination.total"
			></el-pagination>
		</div>

		<el-dialog :title="title" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" :close-on-click-modal="false">
			<div>
				<el-input v-model="tempPaperObj.title" :placeholder="$t('QuesLibrary.Name')" clearable :maxlength="50"></el-input>
				<el-select v-model="tempPaperObj.classification" :placeholder="$t('QuesLibrary.Category')" style="margin: 20px 0px;">
					<el-option v-for="item in options" :key="item.id" :label="item.questionnaireTypeName" :value="item.id"></el-option>
				</el-select>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="dialogVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="medium" type="primary" @click="dialogOk()">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>

		<el-dialog :title="title" :visible.sync="sortVisible" width="30%" :before-close="handleClose" :close-on-click-modal="false">
			<div><el-input-number v-model="sortNum" @change="handleChange" :min="0" :label="$t('QuesLibrary.SortPosition')"></el-input-number></div>

			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="sortVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="medium" type="primary" @click="sortOk()">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>

		<el-dialog :title="$t('QuesLibrary.AddQuestionLabel')" :visible.sync="addEnumByVisible" append-to-body width="800px" :close-on-click-modal="false">
			<el-form :model="addEnumByForm">
				<el-form-item :label="$t('QuesLibrary.TagName')" :label-width="formLabelWidth"><el-input v-model="addEnumByForm.value" autocomplete="off"></el-input></el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer"><el-button size="medium" type="primary" @click="addEnumByOk">{{$t('main.ok')}}</el-button></span>
		</el-dialog>

		<el-dialog :title="$t('QuesLibrary.ModifyProblemLabels')" :visible.sync="editEnumByVisible" append-to-body width="800px" :close-on-click-modal="false">
			<el-form :model="addEnumByForm">
				<el-form-item :label="$t('QuesLibrary.TagName')" :label-width="formLabelWidth"><el-input v-model="addEnumByForm.value" autocomplete="off"></el-input></el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer"><el-button size="medium" type="primary" @click="editEnumByOk">{{$t('main.ok')}}</el-button></span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			formLabelWidth: '120px',
			addEnumByVisible: false,
			editEnumByVisible: false,
			addEnumByForm: {},
			enumByData: [],
			enumBypagination: {
				currentPage: 1,
				pageSize: 10,
				total: 0
			},
			sortId: '',
			sortNum: '',
			sortVisible: false,
			tempPaperObj: {
				title: '',
				classification: ''
			},
			addEditType: 1, //1添加 2编辑
			title: this.$t('QuesLibrary.Tambah'),
			dialogVisible: false,
			tableData: [],
			options: [],
			tempPid: ''
		};
	},
	created() {
		this.loadData();
	},

	methods: {
		addEnumByOk() {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.addEnum}`,
				data: {
					qid: that.wid,
					type: 'bq',
					value: that.addEnumByForm.value
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.loadData();
						that.addEnumByVisible = false;
						that.$message({
							message: res.message,
							type: 'success'
						});
						that.addEnumByForm = {};
					} else {
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		},
		editEnumByOk() {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.modifyEnumById}`,
				data: {
					qid: that.wid,
					type: that.enumByType,
					value: that.addEnumByForm.value,
					id: that.addEnumByForm.id
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.loadData();
						that.editEnumByVisible = false;
						that.$message({
							message: res.message,
							type: 'success'
						});
						that.addEnumByForm = {};
					} else {
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		},
		openEditEnumBy(value) {
			this.addEnumByForm = JSON.parse(JSON.stringify(value));
			this.editEnumByVisible = true;
		},
		delEnumBy(id) {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.removeEnumByIds}`,
				data: {
					qid: that.wid,
					type: that.enumByType,
					id: id
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.loadData();
						that.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		},
		sortOk() {
			let that = this;
			console.log(that.tempPaperObj);
			let questionnaireTypeIdQueries = [];
			let tempObj = {
				id: that.sortId,
				sortnum: that.sortNum
			};
			questionnaireTypeIdQueries.push(tempObj);
			questionnaireTypeIdQueries = JSON.stringify(questionnaireTypeIdQueries);
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.questionnaireTypeSort}`,
				data: questionnaireTypeIdQueries,
				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);

						that.loadData();
						that.sortVisible = false;
						that.sortNum = '';
						that.sortId = '';
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		handleChange(value) {
			console.log(value);
		},
		sortTempPaper(id) {
			this.sortId = id;
			this.sortNum = '';
			this.sortVisible = true;
		},
		dialogOk() {
			if (this.tempPaperObj.title == '') {
				this.$message.warning(this.$t('QuesLibrary.PleaseEnterAName'));
				return false;
			}
			if (this.tempPaperObj.classification == '') {
				this.$message.warning(this.$t('QuesLibrary.PleaseSelectCategory'));
				return false;
			}
			let that = this;
			console.log(that.tempPaperObj);
			let url = '';
			let data = {
				questionnaireTypeName: that.tempPaperObj.title,
				pid: that.tempPaperObj.classification
			};
			if (this.addEditType == 2) {
				url = `${this.$config.service.questionnaireTypeUpdate}`;
				data.id = that.tempPaperObj.id;
			} else {
				url = `${this.$config.service.addQuestionTypes}`;
				delete data.id;
			}
			let params = {
				that: this,
				method: 'POST',
				url: url,
				data: data,
				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);

						that.loadData();
						that.dialogVisible = false;
						that.tempPaperObj = {
							title: '',
							classification: ''
						};
						that.tempPaperObj.classification = '';
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		editTempPaper(data) {
			this.title = this.$t('QuesLibrary.Edit');
			this.addEditType = 2;
			this.dialogVisible = true;
			console.log(data);
			let tempPaperObj = JSON.parse(JSON.stringify(data));
			this.tempPaperObj = {
				title: tempPaperObj.questionnaireTypeName,
				classification: tempPaperObj.pid,
				id: tempPaperObj.id
			};
		},
		adddialogVisible() {
			this.addEnumByForm = {};
			this.addEnumByVisible = true;
			// this.title = '添加';
			// this.addEditType = 1;
			// this.dialogVisible = true;
			// this.tempPaperObj = {
			// 	title: '',
			// 	classification: ''
			// };
		},

		delTempPaper(id) {
			console.log(id);
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.delQuestionTypes}?id=${id}`,

				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);
						that.loadData();
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		handleClose(done) {
			done();
		},
		enumByhandleSizeChange(val) {
			this.enumBypagination.pageSize = val;
			this.loadData();
		},
		enumByhandleCurrentChange(val) {
			this.enumBypagination.currentPage = val;
			this.loadData();
		},
		loadData() {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.queryEnumByType}`,
				data: {
					qid: that.wid,
					type: 'bq',
					pageSize: that.enumBypagination.pageSize,
					currentPage: that.enumBypagination.currentPage
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.enumByData = res.resultBody.records;
						that.enumBypagination.total = res.resultBody.total;
						that.enumByVisible = true;
					} else {
						that.enumByDatac = res.resultBody.records;
						that.enumBypagination.total = res.resultBody.total;
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		}
	}
};
</script>

<style lang="scss" scoped>
.classificationBox {
	padding: 24px;
}
.typeActive {
	color: #0080ff;
}
.block {
	text-align: center;
	margin-top: 20px;
}
</style>
